import type { ReactNode } from 'react';
import { cx } from '../outils';
import { Icone, type NomIcone } from './Icone';

export type TonMessage = 'aide' | 'erreur' | 'avertissement' | 'succes';

const ICONES: Partial<Record<TonMessage, NomIcone>> = {
  erreur: 'circle-alert',
  avertissement: 'triangle-alert',
  succes: 'check',
};

export interface MessageDeChampProps {
  id: string;
  ton?: TonMessage;
  /** Rôle d'annonce (`alert` pour une erreur qui apparaît après un envoi). */
  role?: 'alert' | 'status';
  hidden?: boolean;
  children: ReactNode;
}

/** Texte de 12 px sous un champ, relié par aria-describedby. */
export function MessageDeChamp({ id, ton = 'aide', role, hidden, children }: MessageDeChampProps) {
  const icone = ICONES[ton];
  return (
    <p
      id={id}
      role={role}
      hidden={hidden}
      className={cx('fc-message-de-champ', ton !== 'aide' && `fc-message-de-champ--${ton}`)}
    >
      {icone !== undefined && <Icone nom={icone} />}
      <span className="fc-message-de-champ__texte">{children}</span>
    </p>
  );
}
